import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsByteComponent } from './simple-icons-byte.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsByteComponent ],
    exports:      [ SimpleIconsByteComponent ],
    bootstrap:    []
})
export class SimpleIconsByteModule {}
